export default function ListViewIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="18"
      viewBox="0 0 16 16"
      fill="none"
    >
      <path
        d="M0.5 7.55049C0.5 6.68179 0.6813 6.50049 1.55 6.50049H14.45C15.3187 6.50049 15.5 6.68179 15.5 7.55049V8.45049C15.5 9.31919 15.3187 9.50049 14.45 9.50049H1.55C0.6813 9.50049 0.5 9.31919 0.5 8.45049V7.55049Z"
        stroke="currentColor"
        strokeLinecap="round"
      />
      <path
        d="M0.5 1.55049C0.5 0.681788 0.6813 0.500488 1.55 0.500488H14.45C15.3187 0.500488 15.5 0.681788 15.5 1.55049V2.45049C15.5 3.31919 15.3187 3.50049 14.45 3.50049H1.55C0.6813 3.50049 0.5 3.31919 0.5 2.45049V1.55049Z"
        stroke="currentColor"
        strokeLinecap="round"
      />
      <path
        d="M0.5 13.5505C0.5 12.6818 0.6813 12.5005 1.55 12.5005H14.45C15.3187 12.5005 15.5 12.6818 15.5 13.5505V14.4505C15.5 15.3192 15.3187 15.5005 14.45 15.5005H1.55C0.6813 15.5005 0.5 15.3192 0.5 14.4505V13.5505Z"
        stroke="currentColor"
        strokeLinecap="round"
      />
    </svg>
  );
}
